/// <reference path="tracking.module.ts" />

module Meevo.Components.Tracking {
    /**
     * Service to coordinate preparing data for tracking and sending it to the appropriate API endpoint
     */
    export class TrackingService implements ITrackingService {
        constructor(private $analytics: any,
            private $window: ng.IWindowService,
            private dataService: Meevo.Components.BaseClasses.IDataService) {
            // TODO: Review approaches. We HAVE to make this globally available in order to reach it from 
            // where the angulartics events are hooked.
            this.$window['meevo.components.tracking.TrackingService'] = this;
        }

        onPageTrack(path) {
            // TODO: Implement custom page tracking IF needed.
            // For now, page views are tracked when the event $stateChangeSuccess fires
            // and is handled in app.run.ts
        }

        onEventTrack(action, properties) {
            let noun = properties["noun"];
            let verb = properties["verb"];
            let payload = properties["payload"];

            let trackingItem = new Meevo.Model.TrackingItem(noun, verb, payload);
            this.saveTrackingInfo(trackingItem);
        }

        saveTrackingInfo(item: Meevo.Model.TrackingItem): angular.IPromise<any>;
        saveTrackingInfo(item: Meevo.Model.TrackingItem, sendToProvider?: boolean): angular.IPromise<any> {
            if (sendToProvider) {
                // TODO: Raise Custom Event via Anulartics to Call onEventTrack/onPageTrack above
            }
           
            return this.dataService.trackUsage(item.noun, item.verb, item.details, item.mainEntityId, item.shortDescription);
        }

        savePageView(noun: Meevo.Model.NounEnum): angular.IPromise<any>;
        savePageView(noun: Meevo.Model.NounEnum, details?: any): angular.IPromise<any>;
        savePageView(noun: Meevo.Model.NounEnum, details?: any, mainEntityId?: Guid): angular.IPromise<any> {
            return this.dataService.trackUsage(noun, Meevo.Model.VerbEnum.Viewed, details, mainEntityId);
        }

        static factory(): Function {
            let svc = ($analytics: any, $window: ng.IWindowService, dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new TrackingService($analytics, $window, dataService);
            }

            svc.$inject = ['$analytics', '$window', 'meevo.components.common.DataService'];
            return svc;
        }
    }
    
    angular.module("meevo.components.tracking")
        .factory("meevo.components.tracking.TrackingService", TrackingService.factory());
    
    // Register Angulartics Event Hooks to facilitate recording to our custom repository
    angular.module('meevo')
        .config(['$analyticsProvider', function ($analyticsProvider) {

            $analyticsProvider.registerPageTrack(path => {
                let meevoTracker = window['meevo.components.tracking.TrackingService'];
                if (meevoTracker) {
                    meevoTracker.onPageTrack(path);
                }
            });

            $analyticsProvider.registerEventTrack((action, properties) => {
                let meevoTracker = window['meevo.components.tracking.TrackingService'];
                if (meevoTracker) {
                    meevoTracker.onEventTrack(action, properties);
                }
            });

        }]);
}
